import LiveRamp from './LiveRamp';

export default LiveRamp;
